module.exports = __webpack_public_path__ + "media/images/flags/4x3/syr-b86ca545f438e20dd6a6bd4e0f79e251.svg";